import { useSuspenseQuery } from '@tanstack/react-query';

import { Content } from '@/core/components';

import { ProofAction } from '@feature/proof/ProofAction';
import { ProofUploadRequest } from '@feature/proof/ProofTypes';
import { Author, Id } from '@feature/utils';

import {
  getDoctoralCommitteeProofsOptions,
  useDeleteDoctoralCommitteeProof,
  useUploadOrUpdateDoctoralCommitteeProof,
} from './model/DoctoralCommitteeProofModel';

interface DoctoralCommitteeProofActionProps {
  doctoralCommitteeId: number;
  authors: Author[];
  variant?: 'compact';
}

export function DoctoralCommitteeProofAction({ doctoralCommitteeId, authors }: DoctoralCommitteeProofActionProps) {
  const { data: proofs } = useSuspenseQuery(getDoctoralCommitteeProofsOptions(doctoralCommitteeId));
  const uploadOrUpdateMutation = useUploadOrUpdateDoctoralCommitteeProof(doctoralCommitteeId);
  const deleteMutation = useDeleteDoctoralCommitteeProof(doctoralCommitteeId);

  const handleUpload = (request: ProofUploadRequest) => {
    uploadOrUpdateMutation.mutate(request);
  };

  const handleDelete = (proofId: Id) => {
    deleteMutation.mutate(proofId);
  };

  return (
    <Content type="full">
      <ProofAction
        proofs={proofs}
        entity="doctoral-committee"
        onUpload={handleUpload}
        onDelete={handleDelete}
        isPending={uploadOrUpdateMutation.isPending || deleteMutation.isPending}
        authors={authors}
      />
    </Content>
  );
}
